import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="wrap pb-32 pt-48">
      <p className="eyebrow text-ink/70">404</p>
      <span className="rule mt-5" />
      <h1 className="display mt-8">This address doesn't exist.</h1>
      <p className="mt-5 text-ink/80">The page you're looking for has moved or never existed.</p>
      <Link to="/" className="btn btn-primary mt-9">Back to home</Link>
    </section>
  );
}
